var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStructuredSelections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11686_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3765 28.5849H36.2122V27.1147C36.2122 23.6338 33.3802 20.802 29.8994 20.802H21.9336V15.365H25.4258C27.148 15.365 28.5492 13.9639 28.5492 12.2415V4.65965C28.5492 2.93738 27.148 1.53613 25.4258 1.53613H16.0955C14.3733 1.53613 12.9721 2.9373 12.9721 4.65965V12.2414C12.9721 13.9637 14.3733 15.365 16.0955 15.365H19.5877V20.8019H11.1527C7.67172 20.8019 4.83992 23.6338 4.83992 27.1146V28.5848H3.62352C1.90117 28.5849 0.5 29.9861 0.5 31.7084V35.3401C0.5 37.0624 1.90117 38.4636 3.62352 38.4636H8.40211C10.1244 38.4636 11.5255 37.0624 11.5255 35.3401V31.7084C11.5255 29.9861 10.1244 28.5849 8.40211 28.5849H7.18578V27.1147C7.18578 24.9275 8.96531 23.1479 11.1526 23.1479H19.5877V28.5849H18.3713C16.649 28.5849 15.2478 29.9861 15.2478 31.7084V35.3401C15.2478 37.0624 16.649 38.4636 18.3713 38.4636H23.1499C24.8722 38.4636 26.2734 37.0624 26.2734 35.3401V31.7084C26.2734 29.9861 24.8722 28.5849 23.1499 28.5849H21.9336V23.1479H29.8995C32.0868 23.1479 33.8663 24.9275 33.8663 27.1147V28.5849H32.5978C30.8755 28.5849 29.4744 29.9861 29.4744 31.7084V35.3401C29.4744 37.0624 30.8755 38.4636 32.5978 38.4636H37.3764C39.0988 38.4636 40.4999 37.0624 40.4999 35.3401V31.7084C40.5 29.9861 39.0988 28.5849 37.3765 28.5849Z",
    fill: "url(#paint0_linear_11686_8)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11686_8",
    x1: 5.52532,
    y1: 2.26007,
    x2: 39.9562,
    y2: 31.3369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11686_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructuredSelections);
export default __webpack_public_path__ + "static/media/structured-selections.0bf2c3e01906f789589812343366dafe.svg";
export { ForwardRef as ReactComponent };